module.exports = __webpack_public_path__ + "img/rtmassasment.7e58363c.svg";